import React from 'react';
import style from '../../../PaperworkList/PaperworkList.module.css';
import s from '../../FinancialReport.module.css';
import {FinReportType} from '../../../../types/StoreReportTypes';
type Props = {
	row: FinReportType;
};
const ReportTableRowEl: React.FC<Props> = ({row}) => {
	return (
		<div className={`${style.tableRow} ${s.tableRow}`}>
			{Object.values(row).map((val, i) => (
				<div key={i} className={`${style.tableColumn} ${s.tableColumn}`}>
					{val}
				</div>
			))}
		</div>
	);
};

export default ReportTableRowEl;
